import { useCommonState, useCommonStateActions } from '../../../modules/common'
import { Localidad, Provincia, useGobArActions } from '../../../services/gob-ar'
import { useFileActions } from '../../files'
import { getFileSubPath } from './utils'

export const useAddressLoaders = () => {
    const { provinces, localities } = useCommonState()

    const { setProvinces, setLocalities } = useCommonStateActions()
    const { fetchFileFromSubPath } = useFileActions()
    const { getProvinces: getGobArProvinces, getLocalities: getGobArLocalities } = useGobArActions()

    return () => {
        const readFile = async (listName: string) => {
            try {
                const file = await fetchFileFromSubPath(getFileSubPath(listName))
                const text = await file.text()
                const data = JSON.parse(text)
                return data[listName]
            } catch (error) {
                console.error(`Error reading ${listName} file:`, error)
                return []
            }
        }

        const loadAllProvinces = async (): Promise<Provincia[]> => {
            let list = provinces
            if (list.length === 0) {
                const provincesData = await readFile('provincias') as Provincia[]
                list = provincesData.length > 0 ? provincesData : await getGobArProvinces()
                setProvinces(list || [])
            }
            return list || []
        }

        const loadAllLocalities = async (): Promise<Localidad[]> => {
            let list = localities
            if (list.length === 0) {
                const localitiesData = await readFile('localidades') as Localidad[]
                list = localitiesData.length > 0 ? localitiesData : await getGobArLocalities()
                setLocalities(list || [])
            }
            return list || []
        }

        return {
            loadAllProvinces,
            loadAllLocalities
        }
    }
}
